import React from 'react';
import moment from 'moment';

import EventHeader from './eventHeader';
import ScoreCard from '../../cards/ScoreCard';

import { EventTypes } from '../../../utils/clubs';

const RESULT_DISPLAY_LIMIT = 3;

class MatchList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAllResults: false,
        };
        this.handleScoreUpdateRequest = this.handleScoreUpdateRequest.bind(this);
    }

    handleScoreUpdateRequest(resultId, newStatus) {
        if (this.props.onScoreUpdateRequest) {
            this.props.onScoreUpdateRequest(resultId, newStatus);
        }
    }

    render() {
        const {
            results,
            event,
            draw,
            gameType,
            eligibleResults,
            subscriptionType,
            showVerified,
            playerId,
            limitResultDisplay,
            showDecimalForOwn,
            isProProfile,
            auth,
            redirectUrl,
            scoreStatusMap = new Map(),
            isImportedEventPagesEnabled,
        } = this.props;

        const {
            showAllResults,
        } = this.state;

        const timeZoneValue = event && event.timeZone ? event.timeZone.value : 'UTC';
        const isLeaguesEvent = event?.type === EventTypes.LEAGUES;
        const isTmsEvent = event?.type === EventTypes.TMS || event?.isTms;

        const compareMatches = (match1, match2) => {
            const date1 = moment(match1.date);
            const date2 = moment(match2.date);

            if (date2.isSame(date1)) {
                const roundStrings = ['QF', 'SF', 'F'];
                if (match1.round && match2.round) {
                    const match2Index = roundStrings.indexOf(match2.round.code);
                    const match1Index = roundStrings.indexOf(match1.round.code);

                    if (match1Index === -1 && match2Index === -1) {
                        try {
                            const match1Round = parseInt(match1.round.code.substring(1));
                            const match2Round = parseInt(match2.round.code.substring(1));
                            return match2Round - match1Round;
                        } catch (error) {
                            return 0;
                        }
                    } else {
                        return match2Index - match1Index;
                    }
                } else {
                    return 0;
                }
            } else {
                return date2.isAfter(date1) ? 1 : -1;
            }
        };

        // Filter and slice results based on display requirements
        const getDisplayResults = () => {
            if (!results) {
                return [];
            }

            const sortedResults = results.sort(compareMatches);

            if (!limitResultDisplay) {
                return sortedResults;
            }

            if (showAllResults) {
                return sortedResults;
            }

            return sortedResults.slice(0, RESULT_DISPLAY_LIMIT);
        };

        const displayResults = getDisplayResults();

        return (
            <div>
                <EventHeader
                    startDate={event.startDate}
                    endDate={event.endDate}
                    eventId={event.id}
                    isTms={isTmsEvent}
                    isDualMatch={event.isDualMatch}
                    eventName={event?.name || ''}
                    eventType={event?.type}
                    draw={draw}
                    auth={auth}
                    isLeaguesMatch={isLeaguesEvent}
                    isProProfile={isProProfile}
                    timeZoneValue={timeZoneValue}
                    sportTypeId={event.sportTypeId}
                    results={results}
                    isImportedEventPagesEnabled={isImportedEventPagesEnabled}
                    importedPageReady={event?.importedPageReady}
                    importedEventType={event?.importedEventType}
                />
                {displayResults.map((match) => {
                    const statusData = scoreStatusMap.get(match.id);

                    return (
                        <ScoreCard
                            key={`match-item-${match.id}`}
                            {...match}
                            isProfileResults={true}
                            playerId={playerId}
                            gameType={gameType}
                            eligibleResults={eligibleResults}
                            subscriptionType={subscriptionType}
                            timeZoneValue={timeZoneValue}
                            showVerified={showVerified}
                            showDecimalForOwn={showDecimalForOwn}
                            isProProfile={isProProfile}
                            isLeaguesMatch={isLeaguesEvent}
                            redirectUrl={redirectUrl}
                            sportTypeId={event.sportTypeId || match.sportTypeId}
                            scoreUpdateRequestStatus={statusData?.status || null}
                            batchDataImportType={statusData?.dataImportType || null}
                            batchImportedResult={statusData?.importedResult || false}
                            batchLastUpdated={statusData?.lastUpdated || null}
                            onScoreUpdateRequest={this.handleScoreUpdateRequest}
                            data-testid={`results.match-${match.id}`}
                        />
                    );
                })}
                <div className={`d-flex`}>
                    {limitResultDisplay && results && results.length > RESULT_DISPLAY_LIMIT && (
                        <span
                            className={`text-teal cursor-pointer ml-auto`}
                            onClick={() => {
                                this.setState({
                                    showAllResults: !showAllResults,
                                });
                            }}
                            data-testid="results.match-list.show-all-btn"
                        >
                            {!showAllResults ? 'Show all' : 'Show less'}
                        </span>
                    )}
                </div>
            </div>
        );
    }
}

export default MatchList;
